import { useMemo } from 'react';
import { useRoute } from '@react-navigation/native';

import { MENU_ITEMS_MAP } from '~/components/SideMenu/SideMenu';

export interface ISideMenuOnScreen {
  sideMenuOnScreen: boolean;
}

export const useSideMenuOnScreen = () => {
  const { name: routeName } = useRoute();

  const isWithinSideMenuNavigator = useMemo(
    () => Object.keys(MENU_ITEMS_MAP).some((key) => key === routeName),
    [routeName]
  );

  return isWithinSideMenuNavigator;
};
